import { render, staticRenderFns } from "./index-list.vue?vue&type=template&id=4e8f9898&scoped=true&"
import script from "./index-list.vue?vue&type=script&lang=js&"
export * from "./index-list.vue?vue&type=script&lang=js&"
import style0 from "./index-list.vue?vue&type=style&index=0&id=4e8f9898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f9898",
  null
  
)

export default component.exports